import {Component, OnInit, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PageSubheaderBarConfig } from '../../../fw/pages/page-config-api';
import { FormService } from '../../../fw/services/form.service';
import { SharedService } from '../../shared/shared.service';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SettingsCashregService} from "./settings-cashreg.service";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedValidators} from "../../shared/shared-validators";
import {ValidationMessageComponent} from "../../shared/validation-message.component";
import {DtoArticleForCombi} from "./models/DtoArticleForCombi";
import {DtoArticleCombination} from "./models/DtoArticleCombination";

@Component({
    selector: 'article-combination-search',
    template: require('./article-combination-search.component.html'),
    styles: [require('./article-combination-search.component.css')]
})
@AutoUnsubscribe()

export class ArticleCombinationSearchComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Output() articleChosen = new EventEmitter<DtoArticleForCombi>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    pageSubheaderBarConfig: PageSubheaderBarConfig;
    formSearch: FormGroup;
    formSelection: FormGroup;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '110px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'retailPrice',
            label: 'Prijs',
            type: 'number',
            width: '100px',
            format: '{0:c}'
        }
    ];
    selectedArticle: DtoArticleForCombi;
    objectToEdit: DtoArticleCombination;

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsCashregService,
                private ss: SharedService) { }

    ngOnInit() {
        this.pageSubheaderBarConfig = {
            title: 'ARTIKEL',
            buttonDefinition: [
                {
                    clickEventType: 'choose',
                    description: 'KIEZEN',
                    isSmall: true
                },
                {
                    clickEventType: 'cancel',
                    description: 'ANNULEREN',
                    isSmall: true
                }
            ]
        };

        this.formSearch = this.fb.group({
            description: [''],
            index: [null]
        });

        this.formSelection = this.fb.group({
            retailPrice: [null, [SharedValidators.customNumberRequired]]
        });

        this.formSelection.get('retailPrice').valueChanges.subscribe(newVal => {
            if (this.selectedArticle) {
                this.selectedArticle.retailPriceEx = this.ss.round(((newVal / (100 + this.selectedArticle.btwPercentage)) * 100), 2);
            }
        });

        this.formSelection.valueChanges.subscribe(() => this.validationMessage.getFormValidationErrors());
        this.setObjectToEdit();
    }

    setObjectToEdit() {
        if (this.objectToEdit) {
            this.ds.getArticleForCombi({
                description: '',
                index: 0,
                id: this.objectToEdit.articleId
            }).subscribe(res => {
                this.grid.showData(res);
                if (res.length > 0) {
                    this.grid.setSelectedId(res[0].id);
                    this.selectedArticle = res[0];
                    this.selectedArticle.retailPrice = this.objectToEdit.retailPrice;
                    this.fs.patchDtoToForm(this.selectedArticle, this.formSelection);
                }
            });
        }
    }

    btnClearClicked(event) {
        this.formSearch.reset();
        this.grid.showData([]);
    }

    btnSearchClicked(event) {
        this.ds.getArticleForCombi({
            description: this.formSearch.value.description,
            index: this.formSearch.value.index
        }).subscribe(res => {
            this.grid.showData(res);
        });
    }

    btnSubHeaderBarClicked(event) {
        if (event == 'choose') {
            if (this.selectedArticle) {
                this.validationMessage.validateForm();
                if (this.formSelection.valid) {
                    let result = this.fs.patchFormToDto(this.selectedArticle, this.formSelection);
                    if (this.objectToEdit) {
                        result.index = this.objectToEdit.index;
                    } else {
                        result.index = 0;
                    }
                    this.articleChosen.emit(result);
                    this.closeWindow(false);
                }
            }
        } else if (event == 'cancel') {
            this.closeWindow(false);
        }
    }

    rowDoubleClicked(event) {
        let chosenItem = this.grid.getSelectedItem();
        if (chosenItem) {
            this.validationMessage.validateForm();
            if (this.formSelection.valid) {
                if (this.objectToEdit) {
                    chosenItem.index = this.objectToEdit.index;
                } else {
                    chosenItem.index = 0;
                }
                this.articleChosen.emit(chosenItem);
                this.closeWindow(false);
            }
        }
    }

    gridSelectionChanged(event: DtoArticleForCombi) {
        this.selectedArticle = event;
        this.fs.patchDtoToForm(this.selectedArticle, this.formSelection);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/article-combination-search.component.ts